// extracted by mini-css-extract-plugin
export default {"root":"TeamsystemAppBar_root__3hLA4","navbarWrapper":"TeamsystemAppBar_navbarWrapper__bXt7t","navbarWrapperLogo":"TeamsystemAppBar_navbarWrapperLogo__YnNAV"};